/**
 * Marketing sites JavaScript
 */
import "@babel/polyfill";
import './shared'; // eslint-disable-line no-unused-vars
import './portal/vue';
import quickTip from './portal/quickTip';
import usageChart from './portal/charts';
import budgetChart from './portal/budgetcharts';
import createAccount from './portal/createAccount';
import migrateAccount from './portal/migrateAccount';
import vueInit from './portal/autopay';
import oneTimePayment from './portal/oneTimePayment';
import otherWaysToPay from './portal/otherWaysToPay';
import paymentPlan from './portal/paymentPlanEnroll';
import paymentPlanDetails from './portal/paymentPlanDetails';
import promiseToPay from './portal/promiseToPay';
import promiseToPayStatus from './portal/promiseToPayStatus';
import reportPayment from './portal/reportPayment';
import tables from './portal/tables';
import './portal/alerts';
import chooseAccount from './portal/chooseAccount';
import manageAccounts from './portal/manageAccounts';
import manageAccount from "./portal/manageAccount";
import managePayments from "./portal/managePayments";
import manageService from './portal/manageService';
import usageTable from './portal/usageTable';
import meterUsageComparison from './portal/usageComparison';
import historyTable from './portal/historyTable';
import addLinkedAccount from './portal/addLinkedAccount';
import editLinkedAccount from './portal/editLinkedAccount';
import editContactInfo from './portal/editContactInfo';
import './portal/editProfile';
import './portal/forgotPassword';
import './portal/forgotUsername';
import './portal/resetPassword';
import './portal/manage-subscriptions';
import './portal/budget-payment';
import './portal/paperless';
import './portal/search-web-accounts';
import './portal/web-account-activity';
import greenPath from './portal/greenPath';
import choice from './portal/choice';
import loginModal from './shared/loginModal';
import inactiveUserLogout from './portal/inactiveUserLogout';
import usageBarChart from './portal/usageBarChart';
import downloadHistory from "./portal/downloadHistory";
import downloadBillingHistory from './portal/downloadBillingHistory';
import searchModal from './marketing/vue/searchModal';
import addBankAccount from "./portal/addBankAccount";

createAccount();
migrateAccount();
tables();
usageTable();
meterUsageComparison();
historyTable();
chooseAccount();
manageAccounts();
manageAccount();
managePayments();
manageService();
addLinkedAccount(); // BI.1.2
editLinkedAccount();
editContactInfo();
downloadHistory();
downloadBillingHistory();
addBankAccount();

/*
  Pass the id of the canvas element where you want
  a line chart to output
*/
usageChart();
budgetChart();

vueInit();
oneTimePayment();
otherWaysToPay();
paymentPlan();
promiseToPay();
promiseToPayStatus();
paymentPlanDetails();
reportPayment();
loginModal();
inactiveUserLogout();
usageBarChart();
searchModal();

quickTip();
greenPath();
choice();



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/portal.js